<template>
  <div class="offerExpiredRibbon container">
    <div class="offerExpiredRibbon__Content">
      <Icon name="reset-clock-large" />
      <p v-text="$t('offerExpired')" />
    </div>
  </div>
</template>

<script setup>
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_offerExpiredRibbon.scss');
</style>